import { render, staticRenderFns } from "./TermsVersions.vue?vue&type=template&id=d8a8efac&scoped=true&"
import script from "./TermsVersions.vue?vue&type=script&lang=js&"
export * from "./TermsVersions.vue?vue&type=script&lang=js&"
import style0 from "./TermsVersions.vue?vue&type=style&index=0&id=d8a8efac&scoped=true&lang=css&"
import style1 from "./TermsVersions.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a8efac",
  null
  
)

export default component.exports